import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import FiltrosReporteHistoriaEntity from '../classes/FiltrosReporteHistoriaEntity';

@Injectable({
  providedIn: 'root'
})
export class ServicioImpresionTtaService {

  constructor(private http: HttpClient) { }

  async getReportHistory(filtros: FiltrosReporteHistoriaEntity) {
    const url = `${environment.REPORTES_API}/report/tta/history`;
    const data = {
      tta : filtros.tta,
      cc : filtros.codigBaseDatos,
      type : filtros.isPDF() ? 'pdf' : 'html',
      sede : filtros.sede, 
      firmaProfesional : filtros.firmaProfesional,
      solicitudServicios : filtros.solicitudServicios,
      evoluciones : filtros.evoluciones,
      notas : filtros.notas,
      diligenciados : filtros.diligenciados,
      firmaAfiliado : filtros.firmaAfiliado,
      user: filtros.user
    };
    let options;

    if (filtros.isPDF()) { 
      const headers = new HttpHeaders({'Accept' : 'application/pdf'});
      options = { headers: headers, responseType : 'blob' };
    } else {
      options = { responseType : 'text'}
    }

    return await this.http.post(url, data, options);
  }

  async getReportEvolution(filtros: FiltrosReporteHistoriaEntity) {
    const url = `${environment.REPORTES_API}/report/tta/evolution`;
    const data = {
      tta : filtros.tta,
      cc : filtros.codigBaseDatos,
      type : filtros.isPDF() ? 'pdf' : 'html',
      sede : filtros.sede, 
      firmaProfesional : filtros.firmaProfesional,
      solicitudServicios : filtros.solicitudServicios,
      notas : filtros.notas,
      diligenciados : filtros.diligenciados,
      firmaAfiliado : filtros.firmaAfiliado,
      user: filtros.user
    };
    let options;

    if (filtros.isPDF()) { 
      const headers = new HttpHeaders({'Accept' : 'application/pdf'});
      options = { headers: headers, responseType : 'blob' };
    } else {
      options = { responseType : 'text'}
    }

    return await this.http.post(url, data, options);
  }

  async getReportPregunta(filtros: FiltrosReporteHistoriaEntity) {
    const url = `${environment.REPORTES_API}/report/tta/node`;
    const data = {
      tta : filtros.tta,
      cc : filtros.codigBaseDatos,
      node : filtros.nodo,
      type : filtros.isPDF() ? 'pdf' : 'html',
      sede : filtros.sede, 
      firmaProfesional : filtros.firmaProfesional,
      solicitudServicios : filtros.solicitudServicios,
      evoluciones : filtros.evoluciones,
      notas : filtros.notas,
      diligenciados : filtros.diligenciados,
      firmaAfiliado : filtros.firmaAfiliado,
      user: filtros.user
    };
    let options;

    if (filtros.isPDF()) { 
      const headers = new HttpHeaders({'Accept' : 'application/pdf'});
      options = { headers: headers, responseType : 'blob' };
    } else {
      options = { responseType : 'text'}
    }

    return await this.http.post(url, data, options);
  }

}
